import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useScrollReveal, { useParallax } from './hooks/useScrollReveal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Offices from './components/Offices';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import IntroVideo from './components/IntroVideo';
import AdminBookings from './pages/AdminBookings';

const Landing = () => {
  useScrollReveal();
  useParallax();
  return (
    <div className="relative overflow-x-hidden">
      <IntroVideo />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Offices />
        <Testimonials />
        <Booking />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminBookings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
